var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"onboarding-slide"},[_c('div',[_c('img',{attrs:{"src":_vm.imageSrc(_vm.image)}})]),_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.heading))]),_c('p',[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }